// extracted by mini-css-extract-plugin
module.exports = {"main":"SavedSearchesButton_main__oUJai","main__isHidden":"SavedSearchesButton_main__isHidden__LDw9I"};